import { render, staticRenderFns } from "./HierarchyPersonDetail.vue?vue&type=template&id=66379b60&scoped=true&"
import script from "./HierarchyPersonDetail.vue?vue&type=script&lang=js&"
export * from "./HierarchyPersonDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66379b60",
  null
  
)

export default component.exports